import styled from 'styled-components';

export const StyledNewsCard = styled.div`
   display: flex;
   flex-direction: column;
   flex: 1;
   height: 100%;
   overflow: hidden;
`;
StyledNewsCard.displayName = 'StyledNewsCard';

export const StyledNewsLinksContainer = styled.div`
   display: grid;
   grid-template-columns: 1fr 1fr;
   grid-template-rows: 1fr 1fr;
   grid-gap: 4px;
`;
StyledNewsLinksContainer.displayName = 'StyledNewsLinksContainer';
